<template>
  <div class="course_homepage_wrap" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
    <div class="course_homepage_title">
      <h2>{{getCourseType()}}<span>共{{pageTotal.total>0?pageTotal.total:'0'}}门课</span></h2>
      <div class="search_box">
        <el-input v-model="courseName" placeholder="请输入关键字"></el-input>
        <el-button @click="getListData">查询</el-button>
        <el-button @click="isBlock = !isBlock" :class="isBlock?'block':'list'"></el-button>
        <el-button @click="addCourse" v-if="$_has(createPermissions)" >{{dialogTitle}}</el-button>
      </div>
    </div>
    <div class="course_homepage_main" :style="'height:'+(courseData.length?(windowHeight-210):(windowHeight-170))+'px'" v-if="courseData.length>0">
      <div class="block" style="margin-top: 16px;" v-if="isBlock">
        <ul class="courseData_list">
          <li v-for="(item,key) in courseData" style="    border: solid 1px #e5e5e5;" :data-key="key" :key="key">
            <div class="img_box" @click="previewCourse(item)">
              <img :src="item.courseLogo?item.courseLogo:courseDefPic" alt="加载失败" class="course_logo"/>
              <b v-if="productFlag!='4' && item.status==0">更新中</b>
              <img v-if="item.auth==1" src="../../../../static/images/course/authorize.png" class="authorize"/>
            </div>
            <p class="course_name" :title="item.courseName">{{item.courseName}}</p>
            <div class="course_author">
              <p :title="item.createUserStr">创建人：{{item.createUserStr}}</p>
              <p>课时：{{item.courseHour?item.courseHour:'--'}}</p>
            </div>
            <div class="course_info">
              <p :title="item.courseContext">课程简介：{{item.courseContext?item.courseContext:'无'}}</p>
            </div>
            <div class="course_operation_wrap" v-if="productFlag!='4' && !(item.status==0&&item.auth==1)">
              <p style="text-align: right">
                <span
                  class="publish_course"
                  v-if="isShowAccount&&(item.auth!=1)&&(item.status==0)&&$_has(accountPermissions)&&((item.createUser==userId)||(userType==0))"
                  >
                  <el-switch v-model="item.isInitializeBl" @change="initialize(item)"></el-switch>
                  账套初始化
                </span>
              </p>
              <div class="course_operation" v-if="item.auth!=1"><!--非授权课程-->
                <span class="publish_course" v-if="(item.status==0)&&$_has(publishPermissions)&&((item.createUser==userId)||(userType==0))" @click="isrelease(1,item.id,item.courseHour)">发布</span>
                <span class="offline_course" v-if="(item.status==1)&&$_has(offlinePermissions)&&((item.createUser==userId)||(userType==0))" @click="isrelease(0,item.id,item.courseHour)">下线</span>
                <span class="edit_course" v-if="(item.status==0)&&$_has(editPermissions)&&((item.createUser==userId)||(userType==0))" @click="editCourseBtn(item)">编辑</span>
                <span class="copy_course" v-if="$_has(copyPermissions)&&((item.createUser==userId)||(userType==0))" @click="copyCourse(item)">复制</span>
                <span class="delete_course" v-if="(item.status==0)&&$_has(deletePermissions)&&((item.createUser==userId)||(userType==0))" @click="removeCourseBtn(item.id, item.courseName)">删除</span>
              </div>
            </div>
            <div class="course_operation_wrap" v-if="productFlag=='4' && !(item.status==0&&item.auth==1)">
              <div class="course_operation" v-if="item.auth!=1"><!--非授权课程-->
                <span class="setting_course" v-if="$_has(editPermissions)&&((item.createUser==userId)||(userType==0))" @click="editCourseBtn(item)" style="width: 90px">管理任务</span>
                <span class="delete_course" v-if="$_has(deletePermissions)&&((item.createUser==userId)||(userType==0))" @click="removeCourseBtn(item.id, item.courseName)">删除</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="list" v-else>
        <ul class="courseData_list_two">
          <li v-for="(item,key) in courseData" :data-key="key" :key="key">
            <div class="img_box" @click="previewCourse(item)">
              <img :src="item.courseLogo?item.courseLogo:courseDefPic" alt="加载失败" class="course_logo"/>
              <img v-if="item.auth==1" src="../../../../static/images/course/authorize.png" class="authorize"/>
            </div>
            <div class="course_info_box">
              <p class="course_name" :title="item.courseName">{{item.courseName}}</p>
              <div class="course_author">
                <img src="../../../../static/images/course/teachClassIcon/teacher.png" alt=""><p class="creatUser">创建人：{{item.createUserStr}}</p>
                <img src="../../../../static/images/course/teachClassIcon/classHour.png" alt=""><p class="classHour">课时：{{item.courseHour ? item.courseHour:'--'}}</p>
              </div>
              <div class="course_info">
                <p :title="item.courseContext">课程简介：{{item.courseContext?item.courseContext:'无'}}</p>
              </div>
              <div class="course_operation_wrap" v-if="productFlag!='4' && !(item.status==0&&item.auth==1)">
                <div class="course_operation" v-if="item.auth!=1"><!--非授权课程-->
                  <span class=""
                    style="width: 125px"
                    v-if="isShowAccount&&(item.status==0)&&$_has(accountPermissions)&&((item.createUser==userId)||(userType==0))"
                    >
                    <el-switch v-model="item.isInitializeBl" @change="initialize(item)"></el-switch>
                    账套初始化
                  </span>
                  <span class="publish_course" v-if="(item.status==0)&&$_has(publishPermissions)&&((item.createUser==userId)||(userType==0))" @click="isrelease(1,item.id,item.courseHour)">发布</span>
                  <span class="offline_course" v-if="(item.status==1)&&$_has(offlinePermissions)&&((item.createUser==userId)||(userType==0))" @click="isrelease(0,item.id,item.courseHour)">下线</span>
                  <span class="edit_course" v-if="(item.status==0)&&$_has(editPermissions)&&((item.createUser==userId)||(userType==0))" @click="editCourseBtn(item)">编辑</span>
                  <span class="copy_course" v-if="$_has(copyPermissions)&&((item.createUser==userId)||(userType==0))" @click="copyCourse(item)">复制</span>
                  <span class="delete_course" v-if="(item.status==0)&&$_has(deletePermissions)&&((item.createUser==userId)||(userType==0))" @click="removeCourseBtn(item.id, item.courseName)">删除</span>
<!--                  <span class="edit_course" v-if="userId == 16203" @click="goItCourse(item)">IT课程</span>-->
                </div>
              </div>
              <div class="course_operation_wrap" v-if="productFlag=='4' && !(item.status==0&&item.auth==1)">
                <div class="course_operation" v-if="item.auth!=1"><!--非授权课程-->
									<span class="copy_course" v-if="$_has(copyPermissions)&&((item.createUser==userId)||(userType==0))" @click="copyCourse(item)">复制</span>
                  <span class="setting_course" v-if="$_has(editPermissions)&&((item.createUser==userId)||(userType==0))" @click="editCourseBtn(item)">管理任务</span>
                  <span class="delete_course" v-if="$_has(deletePermissions)&&((item.createUser==userId)||(userType==0))" @click="removeCourseBtn(item.id, item.courseName)">删除</span>
                </div>
              </div>
              <b v-if="productFlag!='4' && item.status==0" class="isUpdate">更新中</b>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="course_kong">
      <img src="../../../../static/images/kong.png" alt="">
      <p>暂无课程</p>
    </div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="$store.state.pageIndex"
			:page-sizes="[10, 20, 50, 100]"
			:page-size="$store.state.pageSizeIndex"
			layout="sizes, prev, pager, next, jumper"
			:total="pageTotal.total"
			background
			v-if="courseData.length">
		</el-pagination>
    <course-dialog
    :title="dialogTitle"
    :showModalconfirm="dialogFormVisible"
    :courseForm="courseForm" @onclickCancel="addCourseCancel"
    v-on:courseInfoUrl="courseInfoUrl"></course-dialog>
  </div>
</template>

<script>
  import * as api from '../../../api/courseApi'
  import axios from 'axios'
  import qs from 'qs'
  import courseDialog from '../../dialog/course/courseInfoDialog'
  export default {
    components: {
      courseDialog
    },
    data() {
      return {
        loading: false,
        windowHeight: window.innerHeight,
        pageTotal: {//分页
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        majorValue: sessionStorage.getItem('professional'),//专业
        courseName: '',
        isBlock: false,
        courseData: [],
        courseDefPic:'/static/images/newCourse/courseCover/cover1.png',
        productFlag: sessionStorage.getItem('productFlag'),
        prodId: sessionStorage.getItem('prodId'),
        createPermissions: '',
        editPermissions: '',
        copyPermissions: '',
        deletePermissions: '',
        publishPermissions: '',
        offlinePermissions: '',
        accountPermissions: '',
        dialogTitle: '创建单项训练',
        dialogFormVisible: false,
        courseForm: {
          courseName: '',
          subject:'',
          type: '',
          coursePic: '',
          classHour: '',
          courseIntroduction: '',
          courseDetails: '',
          "isPay": 1,
          post: []
        },
        userId: sessionStorage.getItem('userId'),
        userType: sessionStorage.getItem('userType'),
        isShowAccount: false
      }
    },
    created(){
      this.handleName();
      this.isShowAccount = (this.majorValue == 1 || this.majorValue == 2 || this.majorValue == 3) ? true : false
    },
    mounted() {
      this.getListData();
    },
    methods: {
      getCourseType(){//左上角title
        let str = ''
        if(this.productFlag==2){
          str = '单项训练库'
        }else if(this.productFlag==3){
          str = '综合实训库'
        }else if(this.productFlag==4){
          str = '真实任务库'
        }else if(this.productFlag==1){
          str = '课程库'
        }
        return str
      },
      handleName(){//获取按钮权限及文字
      	if(this.productFlag==2){
          this.dialogTitle = '创建单项训练'
          this.createPermissions = 'zledu.gxzx.dxxlcourse:save'
          this.editPermissions = 'zledu.gxzx.dxxlcourse:update'
          this.copyPermissions = 'zledu.gxzx.dxxlcourse:copy'
          this.deletePermissions = 'zledu.gxzx.dxxlcourse:delete'
          this.publishPermissions = 'zledu.gxzx.dxxlcourse:publish'
          this.offlinePermissions = 'zledu.gxzx.dxxlcourse:offline'
        }else if(this.productFlag==3){
          this.dialogTitle = '创建综合实训'
          this.createPermissions = 'zledu.gxzx.zhsxcourse:save'
          this.editPermissions = 'zledu.gxzx.zhsxcourse:update'
          this.copyPermissions = 'zledu.gxzx.zhsxcourse:copy'
          this.deletePermissions = 'zledu.gxzx.zhsxcourse:delete'
          this.publishPermissions = 'zledu.gxzx.zhsxcourse:publish'
          this.offlinePermissions = 'zledu.gxzx.zhsxcourse:offline'
          this.accountPermissions = 'zledu.gxzx.zhsxcourse:account'
        }else if(this.productFlag==4){
          this.dialogTitle = '创建真实任务'
          this.createPermissions = 'zledu.gxzx.zsrwcourse:save'
          this.editPermissions = 'zledu.gxzx.zsrwcourse:update'
          this.copyPermissions = 'zledu.gxzx.zsrwcourse:copy'
          this.deletePermissions = 'zledu.gxzx.zsrwcourse:delete'
          this.publishPermissions = 'zledu.gxzx.zsrwcourse:publish'
          this.offlinePermissions = 'zledu.gxzx.zsrwcourse:offline'
        }else if(this.productFlag==1){
          this.dialogTitle = '创建课程'
          this.createPermissions = 'zledu.gxzx.szrtcourse:save'
          this.editPermissions = 'zledu.gxzx.szrtcourse:update'
          this.copyPermissions = 'zledu.gxzx.szrtcourse:copy'
          this.deletePermissions = 'zledu.gxzx.szrtcourse:delete'
          this.publishPermissions = 'zledu.gxzx.szrtcourse:publish'
          this.offlinePermissions = 'zledu.gxzx.szrtcourse:offline'
        }
      },
      getListData() {// 获取课程列表
        let that = this
        that.loading = true
        let obj  = {
          courseName: this.courseName,
          courseProfessional: this.majorValue,
          id: '',
          pageNum: this.$store.state.pageIndex,
          pageSize: this.$store.state.pageSizeIndex,
          type: this.productFlag,
          courseType: this.productFlag==4?4:3,
          prodId: this.prodId
        };
        api.queryCourse(obj).then((rs)=>{
          if(rs.code==0){
            // let courseObj={}
            // let courseArr=[]
            // rs.data.list.forEach((val,i)=>{
            //   courseObj={
            //     auth: val.auth,
            //     courseChapterNum: val.courseChapterNum,
            //     courseContext: val.courseContext,
            //     courseLogo: val.courseLogo,
            //     courseName: val.courseName,
            //     courseProfessional: val.courseProfessional,
            //     courseType: val.courseType,
            //     id: val.id,
            //     schoolId: val.schoolId,
            //     status: val.status,
            //     subjectId: val.subjectId,
            //     type: val.type,
            //     updateUser: val.updateUser,
            //     operate:false,
            //     courseHour: val.courseHour,
            //     createUserStr: val.createUserStr,
            //     subjectName: val.subjectName,
            //     createUser: val.createUser
            //   }
            //   courseArr.push(courseObj)
            // })
            let list = rs.data.list;
            list.forEach(item => item.isInitializeBl = item.isInitialize == 0 ? false : true);
            that.courseData = list
            that.pageTotal.total = rs.data.total
            that.loading = false
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(function (error) {
          console.log(error);
        });
      },
      initialize(obj) {  // 账套初始化
        let params = {
          id: obj.id,
          isInitialize: obj.isInitializeBl ? 1 : 0
        }
        api.updateCourse(params).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess('课程状态已变更')
            this.getListData()
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(error=>{
          console.log(error)
        })
      },
      isrelease(status,id,courseHour){//发布
        let updataData = {
          "status": status,
          "id": id,
          "courseHour": courseHour
        }
        api.updateCourse(updataData).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess('课程状态已变更')
            this.getListData()
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(error=>{
          console.log(error)
        })
      },
      editCourseBtn(item) { // 编辑课程
        // modelType 0 ||null是多资源课程   1 单资源课程
        if (item.modelType == 1){
          this.goItCourse(item)
        }else{
          if(this.productFlag==4){
            this.$router.push({
              path: "/EditTask",
              query: {
                id: item.id,
                subjectId: item.subjectId,
                courseName: item.courseName,
                subjectName: item.subjectName
              }
            })
          }else{
            this.$router.push({
              path: "/EditCourse",
              query: {
                id: item.id,
                subjectId: item.subjectId,
                courseName: item.courseName,
                subjectName: item.subjectName
              }
            })
          }
        }

        this.$store.state.catalogId = '';
      },
      goItCourse(item){
        this.$router.push({
          path: '/zlItCourseEdit',
          query: {
            courseId: item.id,
            courseName:item.courseName,
            subjectId:item.subjectId,
            subjectName:item.subjectName,
            type:item.type,
          }
        })

      },
      removeCourseBtn(id,name) {// 删除课程
        let that = this;
        this.$tipsDialog(
      		"提示",
      		"正在删除课程《"+name+"》",
			    "",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
      	).then(() => {
        	api.deleteCourse(id).then((rs)=>{
            if(rs.code == 0){
              that.$messageSuccess('删除成功');
              that.getListData();
            }else{
              that.$messageError(rs.msg)
            }
          }).catch((error)=>{
            console.log(error)
          })
        }).catch(() => {

        });
      },
      addCourse() {// 添加课程
        this.dialogFormVisible = true;
      },
      addCourseCancel(){//取消添加课程
        this.dialogFormVisible = false
      },
      courseInfoUrl(){//添加课程
        let that = this;
        let arr = []
        if(that.courseForm.post.length>0){
          that.courseForm.post.forEach(v=>{
            arr.push({
              "courseId": '',
              "stationId": v,
              "subjectId": that.courseForm.subject
            })
          })
        }else{
          arr = []
        }
        let addData = {
          "courseLogo": that.courseForm.coursePic,
          "courseName": that.courseForm.courseName,
          "courseProfessional": that.majorValue,
          "courseType": that.productFlag==4?4:3,
          "subjectId": that.courseForm.subject,
          "type": that.productFlag,
          "courseHour": that.courseForm.classHour,
          "courseContext": that.courseForm.courseIntroduction,
          "detail": that.courseForm.courseDetails,
          "courseStationList": arr,
          "isPay": that.courseForm.isPay,
          "prodId": that.prodId,
          prodClassId: sessionStorage.getItem('prodClassId'),
        }
        api.addCourse(addData).then((rs)=>{
          if(rs.code==0){
            that.getListData()
          }else{
            this.$messageError(rs.msg)
          }
          that.dialogFormVisible = false
        }).catch((error)=>{
          console.log(error)
        })
      },
			handleCurrentChange(val) {//分页
				this.$store.state.pageIndex = val;
				this.pageTotal.currentPage = this.$store.state.pageIndex;
	      this.getListData()
	   	},
	   	handleSizeChange(val){//分页
				this.$store.state.pageSizeIndex = val;
	   		this.pageTotal.pageSize = this.$store.state.pageSizeIndex;
	   		this.pageTotal.currentPage = 1;
	      this.getListData()
      },
      copyCourse(item){//复制课程
        // if(this.productFlag!=4){
          api.copyCourse({id:item.id}).then(rs=>{
            if(rs.code==0){
              this.$messageSuccess('复制成功')
              this.getListData()
            }else{
              this.$messageError(rs.msg)
            }
          })
        // }else{
        //   this.$messageWarning('该课程不支持复制')
        // }
      },
      previewCourse(item){//预览课程
        sessionStorage.setItem('isPreview', true)
        const { href } = this.$router.resolve({
          path: '/switch/courseware/preview',
          query: {
            id: item.id,
            subjectId: item.subjectId,
            courseName: item.courseName
          }
        });
        window.open(href, '_blank');
      }
    },
    watch: {
      'isBlock': function(val){
        this.pageTotal.currentPage = 1;
        if(val){
          this.pageTotal.pageSize = 20;
        }else{
          this.pageTotal.pageSize = 10;
        }
        this.getListData()
      }
    }
  }
</script>

<style scoped lang="scss">
  .course_homepage_wrap{
    height: calc(100% - 32px);
    background: #fff;
    padding: 0 16px;
    margin: 16px 16px 0;
    border-radius: 4px;
    .course_homepage_title{
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #DDE0E2;
      h2{
        font-size:16px;
        font-weight: 600;
        color:rgba(13,20,30,1);
        padding-left: 16px;
        position: relative;
        &::after{
          content: '';
          width: 4px;
          height: 12px;
          background: #5397F7;
          position: absolute;
          left: 0;
          top: 6px;
        }
        span{
          font-size:12px;
          font-weight:normal;
          color:rgba(93,100,110,1);
          margin-left: 10px;
        }
      }
      /deep/ .search_box{
        height: 46px;
        display: flex;
        align-items: center;
        .el-input{
          width:298px;
          height:32px;
          .el-input__inner{
            height: 32px;
            line-height: 32px;
            background: #F1F2F4;
          }
        }
        button{
          height:32px;
          border:1px solid rgba(83,151,247,1);
          border-radius:4px;
          color:#fff;
          padding: 0 10px;
          background: #5397F7;
          margin-left: 8px;
          &:hover{
            opacity: 0.8;
          }
        }
        .block{
          width: 32px;
          height: 32px;
          position: relative;
          &::after{
            content: '';
            position: absolute;
            left: 6px;
            top: 8px;
            width: 18px;
            height: 15px;
            background: url('../../../../static/images/course/icon-5.png');
            background-size: 100% 100%;
          }
        }
        .list{
          width: 32px;
          height: 32px;
          position: relative;
          &::after{
            content: '';
            position: absolute;
            left: 6px;
            top: 8px;
            width: 18px;
            height: 15px;
            background: url('../../../../static/images/course/icon-6.png');
            background-size: 100% 100%;
          }
        }
      }
    }
		.el-pagination {
			margin-top: 5px;
		}
    .course_homepage_main{
      overflow-y: auto;
      .block{
        ul{
          display: flex;
          flex-wrap: wrap;
          li{
            width:278px;
            height:306px;
            background:rgba(255,255,255,1);
            // box-shadow:0px 0px 10px rgba(0,0,0,0.11);
            border-radius:4px;
            padding: 16px 19px;
            box-sizing: border-box;
            margin: 10px;
            &:hover{
              box-shadow:0px 0px 10px rgba(0,0,0,0.11);
            }
            .img_box{
              width:240px;
              height:137px;
              background:rgba(255,255,255,1);
              position: relative;
              .course_logo{
                width: 100%;
                height: 100%;
                border-radius:8px;
              }
              b{
                position: absolute;
                right: -4.5px;
                top: 10px;
                background: url('../../../../static/images/course/update-bg.png');
                background-size: 100% 100%;
                width: 61px;
                height: 26px;
                color: #fff;
                font-size: 12px;
                text-align: center;
                line-height: 26px;
                font-weight: 400;
              }
              .authorize{
                position:absolute;
                left:0;
                top:0;
                width: 72px;
                height: 72px;
              }
            }
            .course_name{
              font-size: 16px;
              font-weight: 600;
              color: rgba(13,20,30,1);
              margin: 5px 0 8px 0;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .course_author{
              height: 20px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 8px;
              p{
                font-size:14px;
                font-weight:normal;
                color:rgba(13,20,30,1);
                &:first-child{
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                &:last-child{
                  width: 100px;
                  text-align: right;
                }
              }
            }
            .course_info{
              height: 40px;
              p{
                font-size:12px;
                font-weight:normal;
                line-height:18px;
                color:rgba(93,100,110,1);
                word-break: break-all;
                width: 100%;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
            .course_operation{
              display: flex;
              justify-content: space-around;
              margin-top: 10px;
              span{
                width: 60px;
                line-height: 16px;
                padding-left: 20px;
                box-sizing: border-box;
                font-size: 14px;
                cursor: pointer;
                &:hover{
                  color: #5397F7;
                }
              }
              .publish_course{background: url('../../../../static/images/course/teachClassIcon/fb.png') no-repeat;background-size: 16px 16px;}
              .offline_course{background: url('../../../../static/images/course/teachClassIcon/xx.png') no-repeat;background-size: 16px 16px;}
              .edit_course{background: url('../../../../static/images/course/editSourceIcon/edit.png') no-repeat;background-size: 16px 16px;}
              .setting_course{width: 80px;background: url('../../../../static/images/course/teachClassIcon/setting.png') no-repeat;background-size: 16px 16px;}
              .copy_course{background: url('../../../../static/images/course/teachClassIcon/setting.png') no-repeat;background-size: 16px 16px;}
              .delete_course{background: url('../../../../static/images/course/editSourceIcon/delete.png') no-repeat;background-size: 16px 16px;}
              .publish_course:hover{background: url('../../../../static/images/course/teachClassIcon/fb_hv.png') no-repeat;background-size: 16px 16px;}
              .offline_course:hover{background: url('../../../../static/images/course/teachClassIcon/xx_hv.png') no-repeat;background-size: 16px 16px;}
              .edit_course:hover{background: url('../../../../static/images/course/editSourceIcon/edit-hv.png') no-repeat;background-size: 16px 16px;}
              .setting_course:hover{background: url('../../../../static/images/course/teachClassIcon/setting_hv.png') no-repeat;background-size: 16px 16px;}
              .copy_course:hover{background: url('../../../../static/images/course/teachClassIcon/setting_hv.png') no-repeat;background-size: 16px 16px;}
              .delete_course:hover{background: url('../../../../static/images/course/editSourceIcon/delete-hv.png') no-repeat;background-size: 16px 16px;}
            }
          }
        }
      }
      .list{
        ul{
          li{
            width: calc(100% - 16px);
            height:152px;
            background:rgba(246,248,251,1);
            border-radius:2px;
            display: flex;
            margin-bottom: 8px;
            position: relative;
            &:first-child{
              margin-top: 13px;
            }
            .img_box{
              width:211px;
              height:120px;
              background:rgba(255,255,255,1);
              margin: 16px 20px;
              position: relative;
              img{
                width: 100%;
                height: 100%;
                border-radius: 8px;
              }
              .authorize{
                position:absolute;
                left:0;
                top:0;
                width: 72px;
                height: 72px;
              }
            }
            .course_info_box{
              flex: 1;
              .course_name{
                font-size:16px;
                font-weight:normal;
                color:rgba(13,20,30,1);
                margin-top: 16px;
                margin-bottom: 16px;
                font-weight: 600;
              }
              .course_author{
                width: 350px;
                height: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 8px;
                img{
                  width: 18px;
                }
                p{
                  font-size:14px;
                  font-weight:normal;
                  color:rgba(13,20,30,1);
                  line-height: 16px;
                }
                .creatUser{
                  width: 200px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                .classHour{
                  width: 100px;
                }
              }
              .course_info{
                height: 40px;
                padding-right: 16px;
                p{
                  font-size:12px;
                  font-weight:normal;
                  line-height:18px;
                  color:rgba(93,100,110,1);
                  width: 100%;
                  word-break: break-all;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
              .course_operation_wrap{
                position: absolute;
                right: 16px;
                bottom: 16px;
                .course_operation{
                  display: flex;
                  justify-content: space-around;
                  margin-top: 10px;
                  span{
                    width: 60px;
                    padding-left: 20px;
                    box-sizing: border-box;
                    cursor: pointer;
                    margin-left: 30px;
                    font-size: 12px;
                    line-height: 16px;
                    &:hover{
                      color: #5397F7;
                    }
                  }
                  .publish_course{background: url('../../../../static/images/course/teachClassIcon/fb.png') no-repeat;background-size: 16px 16px;}
                  .offline_course{background: url('../../../../static/images/course/teachClassIcon/xx.png') no-repeat;background-size: 16px 16px;}
                  .edit_course{background: url('../../../../static/images/course/editSourceIcon/edit.png') no-repeat;background-size: 16px 16px;}
                  .setting_course{width: 70px;background: url('../../../../static/images/course/teachClassIcon/setting.png') no-repeat;background-size: 16px 16px;}
                  .copy_course{background: url('../../../../static/images/course/teachClassIcon/setting.png') no-repeat;background-size: 16px 16px;}
                  .delete_course{background: url('../../../../static/images/course/editSourceIcon/delete.png') no-repeat;background-size: 16px 16px;}
                  .publish_course:hover{background: url('../../../../static/images/course/teachClassIcon/fb_hv.png') no-repeat;background-size: 16px 16px;}
                  .offline_course:hover{background: url('../../../../static/images/course/teachClassIcon/xx_hv.png') no-repeat;background-size: 16px 16px;}
                  .edit_course:hover{background: url('../../../../static/images/course/editSourceIcon/edit-hv.png') no-repeat;background-size: 16px 16px;}
                  .setting_course:hover{background: url('../../../../static/images/course/teachClassIcon/setting_hv.png') no-repeat;background-size: 16px 16px;}
                  .copy_course:hover{background: url('../../../../static/images/course/teachClassIcon/setting_hv.png') no-repeat;background-size: 16px 16px;}
                  .delete_course:hover{background: url('../../../../static/images/course/editSourceIcon/delete-hv.png') no-repeat;background-size: 16px 16px;}
                }
              }
              .isUpdate{
                position: absolute;
                right: -4.5px;
                top: 10px;
                background: url('../../../../static/images/course/update-bg.png');
                background-size: 100% 100%;
                width: 61px;
                height: 26px;
                color: #fff;
                font-size: 12px;
                text-align: center;
                line-height: 26px;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
    .course_kong{
      text-align: center;
      img{
        margin-top: 10%;
        margin-bottom: 20px;
      }
      p{
        font-size: 14px;
      }
    }
  }

  /deep/ .el-switch{
    .el-switch__core{
      background: rgba($color: #DCE0E9, $alpha: 0.49);
      border-radius: 10px;
      border: none;
      &::after{
        width: 12px;
        height: 12px;
        background: #BFBFC3;
        top: 4px;
        left: 4px;
      }
    }
  }
  /deep/ .el-switch.is-checked{
    .el-switch__core{
      background: rgba(24, 144, 255, 0.07);
      border-radius: 10px;
      border: none;
      &::after{
        width: 12px;
        height: 12px;
        background: #1890FF;
        top: 4px;
        left: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/course/courseListPage.vue